import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { COLOR_BORDER } from '@assets/color';

const noteStyle = `
  background-attachment: local;
  background-image: linear-gradient(to right, white 10px, transparent 10px),
    linear-gradient(to left, white 10px, transparent 10px),
    repeating-linear-gradient(white, white 30px, #ccc 30px, #ccc 31px, white 31px);
  line-height: 31px;
  padding: 3px 10px;
  border: none;
  outline: none;
  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const CommonTextarea = styled.textarea`
  width: ${({ width }) => width || ' 300px'};
  height: ${({ height }) => height || ' 300px'};
  padding: 10px;
  box-sizing: border-box;
  resize: none;
  font-family: inherit;
  border: 1px solid ${COLOR_BORDER};
  ${({ noteType }) => noteType && noteStyle}
`;

const Textarea = ({
  style,
  className,
  defaultValue,
  value,
  name,
  width,
  height,
  placeholder = '내용을 입력해 주세요.',
  onChange,
  noteType,
}) => {
  const handleChange = (e) => {
    onChange && onChange(e);
  };

  return (
    <CommonTextarea
      style={style}
      className={className}
      defaultValue={defaultValue}
      value={value}
      name={name}
      placeholder={placeholder}
      onChange={handleChange}
      width={width}
      height={height}
      noteType={noteType}
    />
  );
};

Textarea.propTypes = {
  style: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  noteType: PropTypes.bool,
};

export default Textarea;
